<nz-header class="section-header">
  {{ "Depression and Anxiety" | translate }}
</nz-header>

@for (m of modules; track m.path) {
  @if (m.path === componentPaths.geriatricDepressionScale) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="5"
      [historyItems]="getTemplateItems(5)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
}
